(function() {
    'use strict';

    angular.module('doclr.components.disclaimer', [])
        .config(function($stateProvider) {
            $stateProvider.state('disclaimer', {
                url: '/disclaimer',
                templateUrl: '/partials/components/disclaimer.html',
                controller: function($scope) {
                    $scope.naamVennootschap = 'Doclr';
                    $scope.email = 'info@doclr.be';
                    $scope.adresLijn1 = 'Keiberg 6';
                    $scope.adresLijn2 = '3053 Haasrode';
                    $scope.btwNummer = 'BE 0681.682.247';
                    $scope.rpr = '';
                }
            });
        });
})();
